<div class="modal-wrapper">
  <div class="overlay" *ngIf="loading$ | async">
    <app-spinner></app-spinner>
  </div>

  <div class="modal-body company-slide-out-body">
    <div>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <span class="resize" role="button" tabindex="0" aria-label="full screen" (click)="resize()" title="Toggle full width mode">
        <i class="material-icons" *ngIf="!isFullScreen"> fullscreen </i>
        <i class="material-icons" *ngIf="isFullScreen"> fullscreen_exit </i>
      </span>
      <div
        *ngIf="!companySelected"
        class="drill-down-tooltip"
        ngbTooltip="{{ 'company_drill_down_tab' | tpbTooltip }}"
        placement="right"
        tooltipClass="lengthyText"
      ></div>
    </div>
    <p-tabView styleClass="company-slide-out-tabs" [activeIndex]="activeTabIndex" (onChange)="handleChange($event)">
      <p-tabPanel header="Pick Companies">
        <app-company-slide-out-search></app-company-slide-out-search>
      </p-tabPanel>
      <p-tabPanel header="Company Drill Down" [disabled]="!companySelected">
        <app-company-slide-out-drill-down></app-company-slide-out-drill-down>
      </p-tabPanel>
    </p-tabView>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="addCompanies()" [disabled]="(selectedCompaniesCount$ | async) === 0">
      Add Company and Close
    </button>
  </div>
</div>
